import { TYPE } from '@/constants';
import Circle from './circle';

export default class Ellipse extends Circle {
  constructor(params) {
    super(params);
    this.initView();
  }

  initView() {
    this.view.addClass(`shape-${this.subtype}`);
  }

  get subtype() {
    return TYPE.ELLIPSE;
  }

  get radius() {
    return this.shape.radius();
  }

  get width() {
    return this.attributes.width;
  }

  get height() {
    return this.attributes.height;
  }

  toJSON() {
    const { uuid, type, subtype, sid } = this;
    const { cx, cy } = this.rbox();
    const attributes = Object.assign({}, this.attributes, {
      position: [cx, cy],
    });
    return Ellipse.filteredJSON({
      uuid,
      sid,
      type,
      subtype,
      attributes,
    });
  }

  static fromJSON(params) {
    return Ellipse.create(params);
  }

  static create(params) {
    const attributes = {
      position: [0, 0],
      width: 50,
      height: 50,
      styles: {},
    };
    params.attributes = Object.assign({}, attributes, params.attributes);
    return new Ellipse(params);
  }
}
